import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SessionProvider, useSession } from './lib/session.js';
import { Shell } from './components/Shell.js';
import { SignIn } from './screens/SignIn.js';
import { ChangePassword } from './screens/ChangePassword.js';
import { Overview } from './screens/Overview.js';
import { Tenants } from './screens/Tenants.js';
import { TenantDetail } from './screens/TenantDetail.js';
import { Invoices } from './screens/Invoices.js';
import { Promotions } from './screens/Promotions.js';
import { Audit } from './screens/Audit.js';
import { Staff } from './screens/Staff.js';
import { Profile } from './screens/Profile.js';
import { Demo } from './screens/Demo.js';
import { Routes as RoutePerformance } from './screens/Routes.js';

function Authenticated() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/routes" element={<RoutePerformance />} />
            <Route path="/tenants" element={<Tenants />} />
        <Route path="/tenants/:id" element={<TenantDetail />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/audit" element={<Audit />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

function Gate() {
  const { user, loading, mustChangePassword } = useSession();
  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <span
          role="status"
          aria-label="Loading"
          className="h-6 w-6 animate-spin rounded-full border-2 border-black/15 border-t-black/45"
        />
      </div>
    );
  }
  // Ahead of <Authenticated />: on a temporary-password session every panel behind it is refused.
  if (mustChangePassword) return <ChangePassword />;

  return user ? <Authenticated /> : <SignIn />;
}

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Gate />
      </BrowserRouter>
    </SessionProvider>
  );
}
